<template>
    <div class="mc-report-view__table">
        <div class="row mb-3">
            <div class="col-md-6">
                <b-button-group class="mb-3">
                    <b-button @click="isTable = true" :variant="isTable ? 'success' : 'secondary'"><i
                            class="icon-outline_browser"></i> Table</b-button>
                    <b-button @click="isTable = false" :variant="isTable ? 'secondary' : 'success'"><i
                            class="icon-fill_activity"></i> Grafik</b-button>
                </b-button-group>
            </div>

            <!-- Search -->
            <div class="col-md-6">
                <div class="mc-table-view" v-if="isTable">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end float-end">
                        <label class="
                  d-inline-flex
                  align-items-center
                  mc-table-view__search
                ">
                            <i class="mc-fa fas fa-search"></i>
                            <b-form-input v-model="filter" type="search" :placeholder="$t('global.search') + '...'"
                                class="ms-2"></b-form-input>
                        </label>
                    </div>
                </div>
            </div>
            <!-- End search -->
        </div>

        <div class="table-responsive my-3 border border-1" v-if="isTable">
            <b-skeleton-wrapper :loading="isLoading">
                <template #loading>
                    <b-card>
                        <b-skeleton-table :rows="3" :columns="fields.length"
                            :table-props="{ bordered: false, striped: true }">
                        </b-skeleton-table>
                    </b-card>
                </template>
                <b-table class="datatables" :items="listData" :fields="fields" responsive="md" show-empty
                    :empty-text="$t('global.emptyTable')" :per-page="perPage" :current-page="currentPage"
                    :empty-filtered-text="$t('global.emptyFilteredTable')" :filter="filter"
                    :filter-included-fields="filterOn" @filtered="onFiltered" v-if="fields.length > 0">
                    <template #cell(createdOn)="data">
                        {{ momentDateShortMonth(data.item.createdOn) }}<br />
                        <span class="text-muted">{{ momentTimeSeconds(data.item.createdOn) }}</span>
                    </template>
                    <template #cell(driver)="data">
                        {{ data.item.driver ? data.item.driver.fullname : '-' }}
                    </template>
                    <template #cell(vehicle)="data">
                        {{ data.item.vehicle ? data.item.vehicle.licensePlate : '-' }}
                    </template>

                    <template #cell(vehicleType)="data">
                        {{ data.item.vehicle ? (data.item.vehicle.vehicleType ?
                                data.item.vehicle.vehicleType.manufacturer : '-') : '-'
                        }} / {{
                                data.item.vehicle ? (data.item.vehicle.vehicleType ?
                                    data.item.vehicle.vehicleType.model : '-') : '-'
                        }} / {{
                                data.item.vehicle ? (data.item.vehicle.vehicleType ?
                                    data.item.vehicle.vehicleType.type : '-') : '-'
                        }}
                    </template>

                    <template #cell(door1)="data">
                        <span v-if="data.item.door1 !== null">{{ data.item.door1 == 0 ? 'Tertutup' : 'Terbuka' }}</span>
                        <span v-else>-</span>
                    </template>

                    <template #cell(door2)="data">
                        <span v-if="data.item.door2 !== null">{{ data.item.door2 == 0 ? 'Tertutup' : 'Terbuka' }}</span>
                        <span v-else>-</span>
                    </template>

                </b-table>
            </b-skeleton-wrapper>
        </div>
        <div class="row mt-3" v-if="isTable">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                        Menampilkan
                        <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                            :options="pageOptions">
                        </b-form-select>
                        entri. <p>Menampilkan <strong>{{ filteredItems.length > 0 ? ((currentPage - 1) * perPage + 1)
                                : 0
                        }}</strong> - <strong>{{ Math.min(filteredItems.length, (currentPage *
        perPage))
}}</strong> dari <strong>{{ filteredItems.length }}</strong></p>
                    </label>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination v-model="currentPage" :total-rows="totalRows == null ? rows : totalRows"
                            :per-page="perPage"></b-pagination>
                    </ul>
                </div>
            </div>
        </div>

        <div v-if="!isTable">
            <b-skeleton-wrapper :loading="isLoading">
                <template #loading>
                    <b-skeleton-img no-aspect height="400px"></b-skeleton-img>
                </template>
                <LineReport  :labels="chartData.labels" :datasets="chartData.datasets" yLabel="Temperatur (°C)" :y-axes-additional="yAxesAdditional">
                </LineReport>
            </b-skeleton-wrapper>
        </div>
    </div>
</template>
  
<script>
import LineReport from "@/components/Chart/LineReport.vue";
import { GET_REPORT_RAW_SENSOR } from "@/services/api/report/report"
import moment from "moment";
import { Helper } from "@/mixin/helper";
import { Export } from "@/mixin/export";
import { EXPORT_PDF_CHART_RAW_SENSOR, EXPORT_PDF_REPORT_RAW_SENSOR } from "@/services/api/report/pdf";
import { EXPORT_EXCEL_REPORT_RAW_SENSOR } from "@/services/api/report/excel";
moment.locale("id");

export default {
    name: "TemperatureTable",
    components: {
        LineReport
    },
    mixins: [Helper, Export],
    data() {
        return {
            isTable: true,
            series: [
                {
                    name: "Fuel (Liter)",
                    data: [84, 94, 104, 71],
                },
                {
                    name: "Fuel (%)",
                    data: [56, 66, 76, 43],
                },
                {
                    name: "Speed (Km/h)",
                    data: [38, 48, 58, 26],
                },
                {
                    name: "ACC",
                    data: [31, 41, 51, 19],
                },
            ],
            chartData: {
                labels: [],
                datasets: []
            },
            tableData: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            rawSensorInfos: {
                rawSensorInfos: []
            },
            fields: [],
            isLoading: false,
            fileName: '',
            openSection: false,
            periode: [],
            filteredItems: [],
            yAxesAdditional: {
                id: 'pintu',
                ticks: {
                    min: -1,
                    max: 2,
                    stepSize: 0.5,
                    callback: function(label) {
                        if(label == 1) {
                            return 'Terbuka';
                        }else if(label == 0) {
                            return 'Tertutup';
                        }
                    }
                },
                gridLines: {
                    color: 'rgba(166, 176, 207, 0.1)',
                },
                position: 'right',
                scaleLabel: {
                    display: true,
                    labelString: 'Status Pintu'
                }
            },
        };
    },
    computed: {
        rows() {
            return this.rawSensorInfos.rawSensorInfos.length;
        },
        listData() {
            return this.rawSensorInfos.rawSensorInfos;
        }
    },
    watch: {
        isTable(_, newValue) {
            this.$store.commit("report/changeGraphStatus", !newValue);
        }
    },
    mounted() {
        this.totalRows = this.rawSensorInfos.rawSensorInfos.length;

    },
    methods: {
        /**
         * Search the table data with search input
         */

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.filteredItems = filteredItems;
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        refreshData(periode, filter, fields) {
            if (fields.length == 0) {
                this.rawSensorInfos.rawSensorInfos = [];
                return;
            }
            this.fields = fields;
            this.isLoading = true;
            this.periode = periode;
            var filters = {};
            if (filter !== undefined) {
                filters = {
                    vehicleId: parseInt(filter.vehicleId)
                }
            }

            var filterVar = {
                startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
                endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
                type: 'temperature',
                ...filters
            };

            var self = this;
            var getData = this.$apollo
                .query({
                    query: GET_REPORT_RAW_SENSOR,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache'
                }).then(res => {
                    var data = res.data;
                    self.totalRows = data.rawSensorInfos.rawSensorInfos.length;
                    if (data.rawSensorInfos.rawSensorInfos.length === 0) {
                        self.rawSensorInfos.rawSensorInfos = [];
                        self.isLoading = false;
                        return [];
                    }
                    self.isEmpty = false;

                    self.rawSensorInfos.rawSensorInfos = data.rawSensorInfos.rawSensorInfos;
                    self.filteredItems = data.rawSensorInfos.rawSensorInfos;

                    self.chartData.labels = data.rawSensorInfos.rawSensorInfos.map(item => self.momentDMHms(item.createdOn));
                    self.chartData.datasets = [
                        {
                            label: 'Temperatur',
                            data: data.rawSensorInfos.rawSensorInfos.map(item => item.temperature),
                            borderColor: '#000096',
                            fill: false,
                            pointRadius:0,
                            lineTension : 0,
                            borderWidth : 2,
                        }
                    ];

                    var indexDoor1 = self.fields.findIndex(item => {
                        return item.key == 'door1'
                    });

                    if(indexDoor1 >= 0) {
                        self.chartData.datasets.push({
                            yAxisID: 'pintu',
                            label: 'Pintu 1',
                            data: data.rawSensorInfos.rawSensorInfos.map(item => item.door1),
                            borderColor: '#00F00F',
                            fill: false,
                            pointRadius:0,
                            lineTension : 0,
                            borderWidth : 2,
                        })
                    }

                    var indexDoor2 = self.fields.findIndex(item => {
                        return item.key == 'door2'
                    });

                    if(indexDoor2 >= 0) {
                        self.chartData.datasets.push(
                        {
                            yAxisID: 'pintu',
                            label: 'Pintu 2',
                            data: data.rawSensorInfos.rawSensorInfos.map(item => item.door2),
                            borderColor: '#FF6600',
                            fill: false,
                            pointRadius:0,
                            lineTension : 0,
                            borderWidth : 2,
                        })
                    }

                    self.isLoading = false;
                });

            return getData;
        },

        openTable(periode, filter, fields) {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.refreshData(periode, filter, fields);
                    this.openSection = false;
                }, 500);
            })
        },

        downloadToExcel(periode, filter, fields) {
            var filters = {};
            if (filter !== undefined) {
                filters = {
                    vehicleId: filter.vehicleId
                }
            }

            var filterVar = {
                startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
                endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
                subtitle: `Periode : ${this.momentDateLongMonth(periode[0])} - ${this.momentDateLongMonth(periode[1])}`,
                column: fields.map(item => item.header),
                ...filters
            };

            var downloadProgress = {
                name: 'Temperatur ' + moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY") + '.xlsx',
                periode: moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY"),
                downloadedAt: moment().format('DD MMM YYYY HH:mm:ss'),
                percentage: 0,
                type: 'excel'
            };
            this.$store.commit("report/saveProgress", downloadProgress);

            var percentage = 0;
            var intervalDownload = setInterval(() => {
                if (percentage < 75) {
                    percentage += 25;
                } else if (percentage == 75) {
                    percentage = 90;
                } else if (percentage == 90) {
                    clearInterval(intervalDownload);
                }
                this.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: percentage });
            }, 1000);

            var self = this;
            this.$apollo
                .query({
                    query: EXPORT_EXCEL_REPORT_RAW_SENSOR,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache'
                }).then(res => {
                    var isSuccessful = res.data.excelRawSensorInfos.isSuccessful;
                    if (isSuccessful) {
                        clearInterval(intervalDownload);
                        self.$parent.$parent.$parent.refreshDownloadHistory();
                        setTimeout(() => {
                            self.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: 100 });
                            self.$store.commit("report/deleteProgress", downloadProgress);
                        }, 500);
                    } else {
                        clearInterval(intervalDownload);
                        self.$parent.$parent.$parent.refreshDownloadHistory();
                        setTimeout(() => {
                            self.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: 90 });
                            self.$store.commit("report/deleteProgress", downloadProgress);
                        }, 500);
                    }
                })
        },

        downloadToPdf(periode, filter, fields) {
            var filters = {};
            if (filter !== undefined) {
                filters = {
                    vehicleId: filter.vehicleId
                }
            }
            var filterVar = {
                startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
                endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
                column: fields.map(item => item.header),
                subtitle: `Periode : ${this.momentDateLongMonth(periode[0])} - ${this.momentDateLongMonth(periode[1])}`,
                ...filters
            };

            var downloadProgress = {
                name: 'Temperatur ' + moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY") + '.pdf',
                periode: moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY"),
                downloadedAt: moment().format('DD MMM YYYY HH:mm:ss'),
                percentage: 0,
                type: 'pdf'
            };
            this.$store.commit("report/saveProgress", downloadProgress);

            var percentage = 0;
            var intervalDownload = setInterval(() => {
                if (percentage < 75) {
                    percentage += 25;
                } else if (percentage == 75) {
                    percentage = 90;
                } else if (percentage == 90) {
                    clearInterval(intervalDownload);
                }
                this.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: percentage });
            }, 1000);

            var self = this;
            this.$apollo
                .query({
                    query: EXPORT_PDF_REPORT_RAW_SENSOR,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache'
                }).then(res => {
                    var isSuccessful = res.data.pdfRawSensorInfos.isSuccessful;
                    if (isSuccessful) {
                        clearInterval(intervalDownload);
                        self.$parent.$parent.$parent.refreshDownloadHistory();
                        setTimeout(() => {
                            self.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: 100 });
                            self.$store.commit("report/deleteProgress", downloadProgress);
                        }, 500);
                    } else {
                        clearInterval(intervalDownload);
                        self.$parent.$parent.$parent.refreshDownloadHistory();
                        setTimeout(() => {
                            self.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: 90 });
                            self.$store.commit("report/deleteProgress", downloadProgress);
                        }, 500);
                    }
                })
        },

        downloadGraphToPdf(periode, filter) {
            var filters = {};
            if (filter !== undefined) {
                filters = {
                    vehicleId: filter.vehicleId
                }
            }
            var filterVar = {
                startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
                endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
                type: 'temperature',
                ...filters
            };

            var downloadProgress = {
                name: 'Grafik Temperatur ' + moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY") + '.pdf',
                periode: moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY"),
                downloadedAt: moment().format('DD MMM YYYY HH:mm:ss'),
                percentage: 0,
                type: 'pdf'
            };
            this.$store.commit("report/saveProgress", downloadProgress);

            var percentage = 0;
            var intervalDownload = setInterval(() => {
                if (percentage < 75) {
                    percentage += 25;
                } else if (percentage == 75) {
                    percentage = 90;
                } else if (percentage == 90) {
                    clearInterval(intervalDownload);
                }
                this.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: percentage });
            }, 1000);

            var self = this;
            this.$apollo
                .query({
                    query: EXPORT_PDF_CHART_RAW_SENSOR,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache'
                }).then(res => {
                    var isSuccessful = res.data.pdfChartRawSensorInfos.isSuccessful;
                    if (isSuccessful) {
                        clearInterval(intervalDownload);
                        self.$parent.$parent.$parent.refreshDownloadHistory();
                        setTimeout(() => {
                            self.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: 100 });
                            self.$store.commit("report/deleteProgress", downloadProgress);
                        }, 500);
                    } else {
                        clearInterval(intervalDownload);
                        self.$parent.$parent.$parent.refreshDownloadHistory();
                        setTimeout(() => {
                            self.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: 90 });
                            self.$store.commit("report/deleteProgress", downloadProgress);
                        }, 500);
                    }
                })
        }
    },
};
</script>